import {
  LOADING_DATA, LAST_UPDATED, ANALYSIS_LOADING, DASHBOARD_ANALYSIS_DATA, DASHBOARD_DATA,
} from './AppActions';
import { loadTimings, isStreamRequest } from './appUtils';
import { trackTeamDashboardLoad } from '../../util/mixpanel';
import logger from '../../util/logger';

function quietly(work) {
  try {
    work();
  } catch (err) {
    logger.error(err, 'dashboard load timing');
  }
}

function watchResources(collect) {
  const observer = new PerformanceObserver((list) => collect(list.getEntries()));
  observer.observe({ entryTypes: ['resource'] });
  return observer;
}

export const loadTiming = (store) => {
  let load = null;
  let collecting = null;
  let observer = null;

  function collect(entries) {
    if (collecting) {
      collecting.entries.push(...entries.filter(isStreamRequest));
    }
  }

  function send(ended) {
    collect(observer.takeRecords());
    if (collecting === ended) {
      collecting = null;
    }
    trackTeamDashboardLoad(loadTimings(ended));
  }

  function time(action, arrived) {
    const now = performance.now();
    switch (action.type) {
      case LOADING_DATA:
        if (action.isLoading) {
          observer = observer || watchResources(collect);
          load = { dashboardId: store.getState().dashboards.selected._id, start: now, entries: [] };
          collecting = load;
        }
        break;
      case LAST_UPDATED:
        if (load) {
          load.syncReady = load.syncReady || arrived;
        }
        break;
      case ANALYSIS_LOADING:
        if (load && action.analysisLoading) {
          load.analysisStart = now;
        }
        break;
      case DASHBOARD_ANALYSIS_DATA:
        if (load && load.analysisStart) {
          load.analysisEnd = arrived;
        }
        break;
      case DASHBOARD_DATA:
        if (load && !action.fieldType) {
          const ended = load;
          ended.dataArrived = arrived;
          ended.end = now;
          ended.data = action.data;
          load = null;
          setTimeout(() => quietly(() => send(ended)));
        }
        break;
      default:
        break;
    }
  }

  return (next) => (action) => {
    const arrived = performance.now();
    const result = next(action);
    quietly(() => time(action, arrived));
    return result;
  };
};
